import styled from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "Inner",
  componentId: "sc-owesay-0"
})(["display:block;display:flex;flex-wrap:wrap;justify-content:flex-start;> div:first-child{margin-left:0;}> div:last-child{margin-right:0;}"]);